import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.majorScale(1)}px;
`

export const PriceOptionContainer = styled.div`
  border-bottom: 2px ${palette.whiteDove} solid;
  display: flex;
  justify-content: space-between;
  padding: ${spacing.majorScale(1)}px 0;
`
